import { getEanData } from './getEanData'
import { uploadPresigned } from './uploadPresigned.ts'

export default {
  getEanData,
  uploadPresigned
}
